import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'sp0010',
    ecrans: ['00-2']
});
